import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './common.css';
import API_URL from '../common/Apiurl';
import SuccessMessage from '../common/Message';

function Aboutus(){
    const apiUrl = API_URL;
    const [text, setText] = useState('');
    const [successMessages, setSuccessMessages] = useState([]);
    const handleChange = (e) => {
        setText(e.target.value);
    }
    useEffect(() => {
        const aboutData = async (e) => {
            try{
                const putResult = await fetch(`${apiUrl}/admin/getaboutus`,{
                    method: 'GET',
                    headers:{
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                })
                const data = await putResult.json();
                if(data.status === 200){
                    setText(data.value);
                }
            }
            catch(error){
                console.log('Error: ', error)
            }
        }
        aboutData();
    }, []);
    const aboutus = async (e) => { 
        e.preventDefault();
        const postData = {
            aboutContent: text,
        };
        const result = await fetch(`${apiUrl}/admin/aboutus`,{
            method: 'POST',
            headers:{
                "Content-Type":"application/json",
                "Accept":"application/json"
            },
            body: JSON.stringify(postData)
        })
        const data = await result.json();
        if((data.status == 200)){
            const newSuccessMessage = data.message;
            setSuccessMessages([...successMessages, newSuccessMessage]);
            setText(data.value);
        }
    }
    const handleSuccessMessageFadeOut = () =>{
        setSuccessMessages((prevMessages) => prevMessages.slice(1));
        window.location.reload();
    }
    return (
            <div className='width90'>
                <h2 className='pageTitle'>About Us</h2>
                <form onSubmit={aboutus}>
                    {/* <ReactQuill theme="snow" 
                    value={text} 
                    onChange={handleChange} 
                    modules={Aboutus.modules}
                    formtas={Aboutus.formats}
                    /> */}
                    <textarea
                        value={text}
                        onChange={handleChange} >{text}
                    </textarea>
                    <button type='submit' className='submitBtn submitBtnborder'>Submit</button>
                </form>  
                {
                    successMessages.map((message, index) => (
                        <SuccessMessage
                            key={index} 
                            message = {message} 
                            onFadeOut={handleSuccessMessageFadeOut}
                        />
                    )
                )} 
                {/* <div dangerouslySetInnerHTML={{ __html: text }}></div>              */}
            </div> 
    )              
}

Aboutus.modules = {
    toolbar: [
        [{'header':'1'}, {'header':'2'}],
        ['bold','italic', 'underline','strike', 'blockquote'],
        [{'list':'ordered'}, {'list':'bullet'}],
        ['link'],
        ['clean'],
    ],
};
Aboutus.formats = [
    'header',
    'bold','italic', 'underline','strike', 'blockquote',
    'list','bullet',
    'link'
];
export default Aboutus;